module.exports = __webpack_public_path__ + "img/gallery18-1.b8df3c25.jpg";